/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DashboardGraph } from '../models/DashboardGraph';

export class DashboardWithGraphs {
  /**
  * The unique identifier of the dashboard
  */
  'id': string;
  /**
  * The name of the dashboard
  */
  'name': string;
  /**
  * The timestamp when the dashboard was created
  */
  'createdAt': Date;
  /**
  * The timestamp when the dashboard was last updated
  */
  'updatedAt'?: Date | null;
  /**
  * The graphs belonging to this dashboard
  */
  'graphs': Array<DashboardGraph>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "createdAt",
      "baseName": "createdAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "updatedAt",
      "baseName": "updatedAt",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "graphs",
      "baseName": "graphs",
      "type": "Array<DashboardGraph>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DashboardWithGraphs.attributeTypeMap;
  }

  public constructor() {
  }
}

